import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import CommunityManagement from "../components/CommunityManagement";
import UserManagement from "../components/UserManagement";
import CarTypeManagement from "../components/CarTypeManagement";
import PricingPlanManagement from "../components/PricingPlanManagement";
import BookingSlotManagement from "../components/BookingSlotManagement";
import BookingManagement from "../components/BookingManagement";
import DisabledDateManagement from "../components/DisabledDateManagement";
import CouponManagement from "../components/CouponManagement";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const { user: currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("users");

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };
  return (
    <div className="admin-dashboard dark-theme">
      <header className="dashboard-header">
        <div className="header-content">
          <img src={logo} alt="Steam & Drive" className="dashboard-logo" />
          <div className="user-info">
            <span>Admin: {currentUser?.displayName || currentUser?.email}</span>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </div>
      </header>{" "}
      <div className="admin-dashboard-container">
        {" "}
        <nav className="admin-dashboard-nav">
          <div className="admin-nav-tabs">
            <button
              className={`admin-nav-tab ${
                activeTab === "community" ? "active" : ""
              }`}
              onClick={() => setActiveTab("community")}
            >
              <span>🏘️</span>
              Community Management
            </button>{" "}
            <button
              className={`admin-nav-tab ${
                activeTab === "users" ? "active" : ""
              }`}
              onClick={() => setActiveTab("users")}
            >
              <span>👥</span>
              Users
            </button>{" "}
            <button
              className={`admin-nav-tab ${
                activeTab === "car-types" ? "active" : ""
              }`}
              onClick={() => setActiveTab("car-types")}
            >
              <span>🚗</span>
              Car Types
            </button>{" "}
            <button
              className={`admin-nav-tab ${
                activeTab === "pricing" ? "active" : ""
              }`}
              onClick={() => setActiveTab("pricing")}
            >
              <span>💰</span>
              Pricing Plans
            </button>
            <button
              className={`admin-nav-tab ${
                activeTab === "booking-slots" ? "active" : ""
              }`}
              onClick={() => setActiveTab("booking-slots")}
            >
              <span>🕒</span>
              Booking Slots
            </button>{" "}
            <button
              className={`admin-nav-tab ${
                activeTab === "bookings" ? "active" : ""
              }`}
              onClick={() => setActiveTab("bookings")}
            >
              <span>📅</span>
              Bookings
            </button>{" "}
            <button
              className={`admin-nav-tab ${
                activeTab === "disabled-dates" ? "active" : ""
              }`}
              onClick={() => setActiveTab("disabled-dates")}
            >
              <span>🚫</span>
              Disabled Dates
            </button>
            <button
              className={`admin-nav-tab ${
                activeTab === "coupons" ? "active" : ""
              }`}
              onClick={() => setActiveTab("coupons")}
            >
              <span>🎫</span>
              Coupons
            </button>
          </div>
        </nav>{" "}
        <div className="admin-dashboard-content">
          {activeTab === "community" && <CommunityManagement />}{" "}
          {activeTab === "users" && <UserManagement />}
          {activeTab === "car-types" && <CarTypeManagement />}
          {activeTab === "pricing" && <PricingPlanManagement />}
          {activeTab === "booking-slots" && <BookingSlotManagement />}{" "}
          {activeTab === "bookings" && <BookingManagement />}
          {activeTab === "disabled-dates" && <DisabledDateManagement />}
          {activeTab === "coupons" && <CouponManagement />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
